import { fetchWorkflowSteps } from "@/server/api-server";
import environment from "../../../env";
import firebase from "firebase";
import db from "../../../db";
import { cloneDeep } from "lodash-es";

const getGoogleFirestore = function () {
  return environment.backendType !== "ali" ? firebase.firestore() : null;
};
export const namespaced = true;
export const state = {
  steps: [],
  transcriptionMap: {}, // {[key: transcriptionId]: transcription}
  dbTranscriptionMap: {}, // {[key: transcriptionId]: transcription}
  languageCode: "",
  isLocalDataDifferentFromDB: false,
};

export const mutations = {
  MUTATION_STEPS(state, steps) {
    state.steps = steps;
  },
  MUTATION_TRANSCRIPTION_MAP(state, transcription) {
    const { id } = transcription;
    state.transcriptionMap[id] = transcription;
    state.dbTranscriptionMap[id] = cloneDeep(transcription);
  },
  MUTATION_LANGUAGE_CODE(state, languageCode) {
    state.languageCode = languageCode;
  },
  MUTATION_SENTENCE_BY_STEP_ID_AND_INDEX(state, { stepId, sentenceIndex, sentence }) {
    const step = state.steps.find(({ id }) => id === stepId);
    if (!step) {
      console.error(`step data is invalid`);
      return;
    }
    const transcriptionId = step.transcriptions[state.languageCode];
    if (!transcriptionId) {
      console.error(`transcriptionId is invalid`);
      return;
    }
    const transcription = state.transcriptionMap[transcriptionId];
    const sentences = JSON.parse(transcription.sentences);
    sentences[sentenceIndex].sentence = sentence;
    transcription.sentences = JSON.stringify(sentences);
    state.transcriptionMap[transcriptionId] = transcription;
  },
  RESET_IS_LOCAL_DATA_DIFFERENT_FROM_DB(state) {
    state.isLocalDataDifferentFromDB = false;
  },
  RESET_DEFAULT(state) {
    state.steps = [];
    state.transcriptionMap = {};
    state.dbTranscriptionMap = {};
    state.languageCode = "";
    state.isLocalDataDifferentFromDB = false;
  },
};
export const getters = {};

export const actions = {
  async fetchStepsByWorkflowId({ commit, dispatch }, workflowId) {
    const { ok, data } = await fetchWorkflowSteps(workflowId);
    if (!ok) {
      console.error(`Fetching step data occurs an error`);
      return;
    }
    commit("MUTATION_STEPS", data.items);
  },
  async fetchTranscriptionById({ commit }, transcriptionId) {
    this.$db = getGoogleFirestore();
    const transcription = await db.getDocument.call(this, "transcriptions", transcriptionId);
    commit("MUTATION_TRANSCRIPTION_MAP", transcription);
    return transcription;
  },
  storeLanguageCode({ commit }, languageCode) {
    commit("MUTATION_LANGUAGE_CODE", languageCode);
  },
  changeSentenceByStepIdAndSentenceIndex({ commit, dispatch }, { sentenceIndex, stepId, sentence }) {
    commit("MUTATION_SENTENCE_BY_STEP_ID_AND_INDEX", { sentenceIndex, stepId, sentence });
    dispatch("compareDBTranscriptionAndLocalTranscription");
  },
  compareDBTranscriptionAndLocalTranscription({ state }) {
    state.isLocalDataDifferentFromDB =
      Object.values(state.transcriptionMap).length !== Object.values(state.dbTranscriptionMap).length;
    if (state.isLocalDataDifferentFromDB) {
      return;
    }
    for (let i = 0; i < state.steps.length; i++) {
      const transcriptionId = state.steps[i].transcriptions[state.languageCode];
      const localTranscription = state.transcriptionMap[transcriptionId];
      const dbTranscription = state.dbTranscriptionMap[transcriptionId];
      if (!localTranscription || !dbTranscription || localTranscription.sentences !== dbTranscription.sentences) {
        state.isLocalDataDifferentFromDB = true;
        break;
      }
    }
  },
  generateTranscriptionBatch({ state }) {
    return state.steps.map((step) => {
      const transcriptionId = step.transcriptions[state.languageCode];
      return {
        type: "update",
        collection: "transcriptions",
        id: transcriptionId,
        data: state.transcriptionMap[transcriptionId],
      };
    });
  },
  resetStepSentenceState({ commit }) {
    commit("RESET_DEFAULT");
  },
  resetIsLocalDataDifferentFromDB({ commit }) {
    commit("RESET_IS_LOCAL_DATA_DIFFERENT_FROM_DB");
  },
  checkEmptySentence() {
    let isEmpty = false;
    for (const transcriptionId in state.transcriptionMap) {
      if (isEmpty) {
        break;
      }
      const transcription = state.transcriptionMap[transcriptionId];
      for (const sentences of JSON.parse(transcription.sentences)) {
        if (sentences.sentence === "") {
          isEmpty = true;
          break;
        }
      }
    }
    return isEmpty;
  },
};
